// extracted by mini-css-extract-plugin
export default {"contentInnerContainer":"tenant-create_contentInnerContainer__s1PJ7","item":"tenant-create_item__Z7r9V"};